export default __webpack_public_path__ + "static/media/DNo.39-0.5b014919.jpg";